import { SessionService } from './../../../auth/_services/session.service';
import { User } from './../../../auth/_models/user';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';

declare let App: any;
declare let CustomScript: any;

@Component({
  selector: 'app-page-header, [app-page-header]',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css']
})
export class PageHeaderComponent implements OnInit, AfterViewInit {

  user: User;

  parentTitle = '';
  title = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _sessionService: SessionService,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .map(() => this.activatedRoute)
      .map((route) => {
        while (route.firstChild) { route = route.firstChild; }
        return route;
      })
      .filter((route) => route.outlet === 'primary')
      .mergeMap((route) => route.data)
      .subscribe((event) => {
        const parent = event['parent'];
        const title = event['title'];

        this.setTitle(title, parent);
      });

    this._sessionService.getUser().subscribe(user => {
      this.user = user;
    });
  }

  ngAfterViewInit() {
    App.initBeforeLoad();
    App.initCore();
    App.initAfterLoad();
    CustomScript.init();
  }

  setTitle(newTitle: string, newParentTitle: string): void {
    if (newParentTitle) {
      this.parentTitle = newParentTitle;
      this.title = newTitle;
    } else {
      this.title = '';
      this.parentTitle = newTitle;
    }
  }

}
